'use strict';

angular.module('ClinicApp').controller('ModalClinicManualInstantBookExperiment', function(clinic, $scope, $modalInstance, OpencareConstants, localStorageService) {
  $scope.clinic = clinic;

  $scope.close = function() {
    localStorageService.cookie.set(OpencareConstants.manualIBExperiment.MODAL_CLOSED, 'true');
    $modalInstance.close(false);
  };
});
